import { Component, Input, OnInit } from '@angular/core';
import { MultiDataInput } from 'src/app/constants/constants';

@Component({
  selector: 'app-multi-data',
  templateUrl: './multi-data.component.html',
  styleUrls: ['./multi-data.component.scss']
})
export class MultiDataComponent implements OnInit {
  @Input() multiData: MultiDataInput = {
    type: '',
    data: '',
    tikzId: '',
    imageKeys: [],
    listOfImages: null,
    videos: [],
    videoMap: new Map<number, any>()
  };

  constructor() {}

  ngOnInit() {}
}
